<template>
  <div>
    <InfoBanner page="account_overview" />
    <div class="account container">
      <loader v-show="isLoading" />
      <div v-if="!isLoading && loadFailed" class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <p>{{ $t("views.account.loadFailed") }}</p>
            <button class="btn btn-primary" @click="reloadPage">
              {{ $t("app.refreshAgain") }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="!isLoading && !loadFailed" class="container">
        <div class="row">
          <div class="col-lg-12">
            <before-form-header
              :title="$t('views.account.overview')"
              class="header-table over-header"
              description=""
            />
            <div class="row overview">
              <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div class="your" v-if="overviewData">
                  <div class="top">
                    <div class="header0">
                      {{ $t("views.account.accountBalance") }}
                    </div>
                    <div class="header-value" align="center">
                      {{ overviewData.funds.total | moneyFormatter00 }}
                    </div>
                  </div>
                  <div class="info-table">
                    <hr />
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.availableFunds") }}
                      </div>
                      <div class="col-4 text-right">
                        {{ overviewData.funds.available | moneyFormatter00 }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.investedFunds") }}
                      </div>
                      <div class="col-4 text-right">
                        {{ overviewData.funds.invested | moneyFormatter00 }}
                      </div>
                    </div>
                    <hr />
                    <div class="row total">
                      <div class="col-3 total-header">
                        {{ $t("views.account.total") }}
                      </div>
                      <div class="col-9 text-right total-value">
                        {{ overviewData.funds.total | moneyFormatter00 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div class="your" v-if="overviewData">
                  <div class="top">
                    <div class="header0">
                      {{ $t("views.account.earnings")
                      }}<help-tooltip
                        :tooltipText="$t('views.account.earningsTooltip')"
                      ></help-tooltip>
                    </div>
                    <div class="header-value" align="center">
                      {{
                        showAsPercentages(
                          overviewData.earnings.nominal_return_rate
                        )
                      }}
                    </div>
                    <div
                      v-if="
                        overviewData.earnings
                          .percent_including_campaign_reward > 0
                      "
                      class="header-description"
                    >
                      {{
                        $t("views.account.includingCampaign", {
                          "1": showAsPercentages(
                            overviewData.earnings
                              .percent_including_campaign_reward
                          ),
                        })
                      }}
                    </div>
                  </div>
                  <div class="info-table">
                    <hr />
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.accruedInterest") }}
                        <help-tooltip
                          :tooltipText="
                            $t('views.account.accruedInterestTooltip')
                          "
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{
                          overviewData.earnings.accrued_earnings
                            | moneyFormatter00
                        }}
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.interest") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.interestTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{ overviewData.earnings.interest | moneyFormatter00 }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.interestYtd") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.interestYtdTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{
                          overviewData.marketplace_earned.ytd | moneyFormatter00
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.interestMtd") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.interestMtdTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{
                          overviewData.marketplace_earned.mtd | moneyFormatter00
                        }}
                      </div>
                    </div>
                    <!--                  <div class="row">-->
                    <!--                    <div class="col-8">{{ $t('views.account.secondaryMarketTransaction') }}<img alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover :title="$t('views.account.secondaryMarketComingSoon')"/></div>-->
                    <!--                    <div class="col-4">{{ overviewData.earnings.secondary_market_transaction | moneyFormatter }}</div>-->
                    <!--                  </div>-->
                    <!--                  <div class="row">
                      <div class="col-8">{{ $t('views.account.campaignRewards') }}</div>
                      <div class="col-4 text-right">{{ overviewData.earnings.campaign_rewards | moneyFormatter00 }}</div>
                    </div> -->
                    <!--                  <div class="row">-->
                    <!--                    <div class="col-8">{{ $t('views.account.inviteFriendsAnd') }}</div>-->
                    <!--                    <div class="col-4 text-right"><router-link to="/invite" @click.native="scrollToTop" target="_blank">{{ $t('views.account.clickHere') }}</router-link></div>-->
                    <!--                  </div>-->
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.bonus") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.bonusTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{
                          overviewData.earnings.campaign_rewards
                            | moneyFormatter00
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8 info-title">
                        {{ $t("views.account.inviteFriendsAnd1") }}
                      </div>
                      <div class="col-4 text-right">
                        <router-link
                          :to="$t('router.links.invite')"
                          @click.native="scrollToTop"
                          >{{ $t("views.account.earnMore") }}</router-link
                        >
                      </div>
                    </div>
                    <hr />
                    <div class="row total">
                      <div class="col-5 total-header">
                        {{ $t("views.account.totalProfit")
                        }}<help-tooltip
                          :tooltipText="$t('views.account.totalProfitTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-7 text-right total-value">
                        {{
                          overviewData.earnings.total_profit | moneyFormatter00
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="overviewData"
                class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
              >
                <div class="your">
                  <div class="top">
                    <div class="header0">
                      {{ $t("views.account.portfolio") }}
                    </div>
                    <div class="header-value" align="center">
                      {{
                        $t("views.account.investments", {
                          "1": overviewData.portfolio.investment_count,
                        })
                      }}
                    </div>
                    <div class="header-description">
                      {{ $t("views.account.outstandingPrincipalAmounts") }}
                    </div>
                  </div>
                  <div class="info-table">
                    <hr />
                    <div class="row">
                      <div class="col-5 info-title">
                        {{ $t("views.account.current") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.currentTooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-4 text-right">
                        {{
                          overviewData.portfolio.current_funds
                            | moneyFormatter00
                        }}
                      </div>
                      <div class="col-3 text-right">
                        {{
                          showAsPercentages(
                            overviewData.portfolio.current_percents,
                            1
                          )
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 info-title">
                        {{ $t("views.account.dLate")
                        }}<img
                          id="days_15"
                          class="help-tooltip"
                          alt=""
                          v-bind:src="getSrc('help.svg')"
                          v-b-tooltip.hover
                        />
                      </div>
                      <b-tooltip target="days_15" triggers="hover"
                        >{{ $t("views.account.paymentsForThis") }}<br />{{
                          $t("views.account.borrowersRepayments")
                        }}
                        {{ $t("views.account.5970") }}<br />
                        {{ $t("views.account.interestEarning") }}</b-tooltip
                      >
                      <div class="col-4 text-right">
                        {{
                          overviewData.portfolio.days_late_15 | moneyFormatter00
                        }}
                      </div>
                      <div class="col-3 text-right">
                        {{
                          showAsPercentages(
                            overviewData.portfolio.days_late_15_percents,
                            1
                          )
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 info-title">
                        {{ $t("views.account.dLate1")
                        }}<img
                          id="days_16"
                          class="help-tooltip"
                          alt=""
                          v-bind:src="getSrc('help.svg')"
                          v-b-tooltip.hover
                        />
                      </div>
                      <b-tooltip target="days_16" triggers="hover"
                        >{{ $t("views.account.paymentsForThis1") }}<br />{{
                          $t("views.account.1670")
                        }}
                        <br />
                        {{ $t("views.account.interestEarning") }}</b-tooltip
                      >
                      <div class="col-4 text-right">
                        {{
                          overviewData.portfolio.days_late_30 | moneyFormatter00
                        }}
                      </div>
                      <div class="col-3 text-right">
                        {{
                          showAsPercentages(
                            overviewData.portfolio.days_late_30_percents,
                            1
                          )
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-5 info-title">
                        {{ $t("views.account.dLate2")
                        }}<img
                          id="days_60"
                          class="help-tooltip"
                          alt=""
                          v-bind:src="getSrc('help.svg')"
                          v-b-tooltip.hover
                        />
                      </div>
                      <b-tooltip target="days_60" triggers="hover"
                        >{{ $t("views.account.paymentsForThis2") }}<br />{{
                          $t("views.account.9050")
                        }}
                        <br />
                        {{ $t("views.account.interestEarning") }}</b-tooltip
                      >
                      <div class="col-4 text-right">
                        {{
                          overviewData.portfolio.days_late_60 | moneyFormatter00
                        }}
                      </div>
                      <div class="col-3 text-right">
                        {{
                          showAsPercentages(
                            overviewData.portfolio.days_late_60_percents,
                            1
                          )
                        }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 info-title">
                        {{ $t("views.account.dLate3") }}
                        <help-tooltip
                          :tooltipText="$t('views.account.dLate3Tooltip')"
                        ></help-tooltip>
                      </div>
                      <div class="col-3 text-right">
                        {{
                          overviewData.portfolio.days_late_buyback_initiated
                            | moneyFormatter00
                        }}
                      </div>
                      <div class="col-3 text-right">
                        {{
                          showAsPercentages(
                            overviewData.portfolio
                              .days_late_buyback_initiated_percents,
                            1
                          )
                        }}
                      </div>
                    </div>
                    <!--                  <div class="row">-->
                    <!--                    <div class="col-5">{{ $t('views.account.default') }}<img alt="" v-bind:src="getSrc('help.svg')" v-b-tooltip.hover :title="$t('views.account.allLoansWhich')"/></div>-->
                    <!--                    <div class="col-4 text-right">{{ overviewData.portfolio.default | moneyFormatter00 }} </div>-->
                    <!--                    <div class="col-3 text-right">{{ showAsPercentages(overviewData.portfolio.default_percents) }}</div>-->
                    <!--                  </div>-->
                    <hr />
                    <div class="row total">
                      <div class="col-5 total-header">
                        {{ $t("views.account.total1") }}
                      </div>
                      <div class="col-7 text-right total-value">
                        {{ overviewData.portfolio.total | moneyFormatter00 }}
                      </div>
                    </div>
                    <div class="strategies-link">
                      <router-link
                        to="/invest?tab=2"
                        @click.native="scrollToTop"
                        >{{
                          $t("views.account.viewYourAutomated")
                        }}</router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="graphs">
              <div v-if="chartsPending" class="row">
                <div class="col-12">
                  <div class="alert alert-info" role="status">
                    {{ $t("views.account.chartsPending") }}
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="overviewData && overviewData.my_cashflow.loans_count > 0"
              >
                <div class="col-12">
                  <div class="future-cashflow">
                    <div class="w-100">
                      <h3>{{ $t("views.account.futureCashflow") }}</h3>
                    </div>
                    <div
                      v-if="
                        overviewData && overviewData.my_cashflow.loans_count > 0
                      "
                    >
                      {{ $t("views.account.youHaveDone") }}
                      {{ overviewData.my_cashflow.loans_count }}
                      {{ $t("views.account.investment")
                      }}{{
                        overviewData.my_cashflow.loans_count > 1
                          ? $t("views.account.s")
                          : ""
                      }}
                      {{ $t("views.account.from") }}
                      {{ overviewData.my_cashflow.countries_count }}
                      {{ $t("views.account.countries") }}
                      {{
                        overviewData.my_cashflow.days > 0
                          ? $t("views.account.averageMaturityIs", {
                              "1": overviewData.my_cashflow.days,
                            })
                          : ""
                      }}
                    </div>
                    <div
                      class="investments-chart col-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <!--                    <line-chart :chart-data="chartData.lineMyCashflowInFutureChart" :options="chartOptions"/>-->
                      <mixed-chart
                        :data-to-render="
                          this.chartData.lineMyCashflowInFutureChart
                        "
                        :display-dots="false"
                      />
                      <!--                    {{this.chartData.lineMyCashflowInFutureChart}}-->
                    </div>
                    <div class="col-12">
                      <ul class="nolist">
                        <li>
                          <b>{{ $t("views.account.toTheEnd") }}</b
                          >{{
                            $t(
                              "views.account.includesAlsoOverduependingAmounts"
                            )
                          }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  v-if="chartData.pieByLoanType"
                  class="col-12 col-md-6 col-lg-6 col-xl-6 assets-chart-section"
                >
                  <div class="assets-chart">
                    <div v-if="pieByLoanMode === 0">
                      <h4>{{ $t("views.account.assetsInvestedBy") }}</h4>
                      <DoughnutChartOverviewSection
                        v-if="chartData.pieByLoanType"
                        :categories="chartData.pieByLoanType"
                      />
                    </div>
                    <div v-if="pieByLoanMode === 1">
                      <h4>{{ $t("views.account.assetsInvestedByLO") }}</h4>
                      <DoughnutChartOverviewSection
                        v-if="chartData.pieByLoanOriginator"
                        :categories="chartData.pieByLoanOriginator"
                      />
                    </div>
                    <div class="text-center w100">
                      <b-row
                        class="tab-switcher"
                        align-v="center"
                        align-h="center"
                      >
                        <b-tabs
                          v-model="pieByLoanMode"
                          pills
                          nav-wrapper-class="income-tabs"
                        >
                          <b-tab
                            :title="$t('views.account.byLoanTypeMode')"
                          ></b-tab>
                          <b-tab
                            :title="$t('views.account.byLoanOriginatorMode')"
                          ></b-tab>
                        </b-tabs>
                      </b-row>
                    </div>
                  </div>
                </div>
                <div
                  v-if="chartData.pieByCountry"
                  class="col-12 col-md-6 col-lg-6 col-xl-6 assets-chart-section"
                >
                  <div class="assets-chart">
                    <div v-if="pieByContryDurationMode === 0">
                      <h4>{{ $t("views.account.assetsInvestedByCountry") }}</h4>
                      <DoughnutChartOverviewSection
                        v-if="this.chartData.pieByCountry"
                        :categories="this.chartData.pieByCountry"
                      />
                    </div>
                    <div v-if="pieByContryDurationMode === 1">
                      <h4>
                        {{ $t("views.account.assetsInvestedByRemainingLoan") }}
                      </h4>
                      <DoughnutChartOverviewSection
                        v-if="this.chartData.pieByLoanDuration"
                        :categories="this.chartData.pieByLoanDuration"
                      />
                    </div>
                    <div class="text-center w100">
                      <b-row
                        class="tab-switcher"
                        align-v="center"
                        align-h="center"
                      >
                        <b-tabs
                          v-model="pieByContryDurationMode"
                          pills
                          nav-wrapper-class="income-tabs"
                        >
                          <b-tab
                            :title="$t('views.account.byCountryMode')"
                          ></b-tab>
                          <b-tab
                            :title="$t('views.account.byLoanDurationMode')"
                          ></b-tab>
                        </b-tabs>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BeforeFormHeader from "../components/BeforeFormHeader";
import Loader from "@/components/Loader";
import InfoBanner from "@/components/InfoBanner";
import imageMixin from "@/mixins/image";
import moneyMixin from "../mixins/money";
import investor from "@/api/investor";
import HelpTooltip from "@/components/HelpTooltip";
import loadingMixin from "../mixins/loading";
import MixedChart from "@/components/charts/MixedChart.js";
import DoughnutChartOverviewSection from "@/components/charts/complex/DoughnutChartOverviewSection";

export default {
  components: {
    MixedChart,
    Loader,
    InfoBanner,
    BeforeFormHeader,
    HelpTooltip,
    DoughnutChartOverviewSection,
  },
  mixins: [imageMixin, moneyMixin, loadingMixin],
  data() {
    return {
      settings: null,
      investorDetails: this.$store.state.investors.investor,
      isLoading: true,
      isInvestorDataLoaded: false,
      loadFailed: false,
      overviewData: null,
      // Set from charts.pending. True when the backend found this investor's cached figures cold
      // and too heavy to rebuild inside the request, so it queued the recalculation instead. The
      // balances, earnings and portfolio blocks are read live and stay correct; only the charts
      // below come back empty, so we say so rather than drawing five blank boxes.
      chartsPending: false,
      chartData: {
        lineMyCashflowInFutureChart: null,
        pieByLoanType: null,
        pieByCountry: null,
        pieByLoanOriginator: null,
        pieByLoanDuration: null,
      },
      statusesData: null,
      pieByLoanMode: 0,
      pieByContryDurationMode: 0,
    };
  },
  watch: {
    loaded: "syncLoadingState",
    isInvestorDataLoaded: "syncLoadingState",
  },
  mounted() {
    investor
      .getInvestorDetails()
      .then((response) => {
        this.overviewData = response;
        // Fix for new users for invite
        if (response.investor_invitation_code_to_share) {
          this.$store.state.investors.investor.investor_invitation_code_to_share =
            response.investor_invitation_code_to_share;
        }
        this.chartsPending = response.charts.pending === true;
        this.chartData.lineMyCashflowInFutureChart =
          response.charts.data.my_cashflow_line;
        if (this.chartData.lineMyCashflowInFutureChart.datasets) {
          // TODO CHANGE SETTINGS ON BE!
          if (this.chartData.lineMyCashflowInFutureChart.datasets[0]) {
            if (
              this.chartData.lineMyCashflowInFutureChart.datasets[0].label_i18n
            ) {
              this.chartData.lineMyCashflowInFutureChart.datasets[0].label =
                this.$t(
                  this.chartData.lineMyCashflowInFutureChart.datasets[0]
                    .label_i18n
                );
              // this.chartData.lineMyCashflowInFutureChart.datasets[0].data = [
              //     1000, 2000, 1500, 1000, 2500, 10000, 15000, 1200, 1000, 2000, 1500, 1000, 2500, 10000,15000
              // ]
            }
          }
          if (this.chartData.lineMyCashflowInFutureChart.datasets[1]) {
            this.chartData.lineMyCashflowInFutureChart.datasets[1].backgroundColor =
              "#BB86FC";
            this.chartData.lineMyCashflowInFutureChart.datasets[1].borderColor =
              "#BB86FC";
            if (
              this.chartData.lineMyCashflowInFutureChart.datasets[1].label_i18n
            ) {
              this.chartData.lineMyCashflowInFutureChart.datasets[1].label =
                this.$t(
                  this.chartData.lineMyCashflowInFutureChart.datasets[1]
                    .label_i18n
                );
            }
            // this.chartData.lineMyCashflowInFutureChart.datasets[1].data = [
            //   1500, 1800, 1600, 1200, 2550, 10500, 14000, 1250, 900, 1500, 1800, 1600, 1200, 2550, 10500
            // ]
          }
        }
        this.chartData.pieByCountry = response.charts.data.by_country;
        const pieByCountry = response.charts.data.by_country;
        let statusesData = [];
        if (pieByCountry && pieByCountry.datasets && pieByCountry.datasets[0]) {
          // eslint-disable-next-line camelcase
          pieByCountry.labels_i18n.forEach((i18n_label, index) => {
            const dataset = pieByCountry.datasets[0];
            statusesData.push({
              name: this.$t(i18n_label),
              amount: dataset.data[index],
              color: dataset.backgroundColor[index],
            });
          });
        }
        this.chartData.pieByCountry = [
          {
            categoryName: "Assets invested by Country",
            data: statusesData,
          },
        ];

        // Override/Set lineTension
        if (
          this.chartData.lineMyCashflowInFutureChart.datasets &&
          this.chartData.lineMyCashflowInFutureChart.datasets[1]
        ) {
          this.chartData.lineMyCashflowInFutureChart.datasets[1].lineTension = 0.2;
        }

        this.chartData.pieByLoanType = response.charts.data.by_loan_type;
        const pieByLoanType = response.charts.data.by_loan_type;
        statusesData = [];
        if (
          pieByLoanType &&
          pieByLoanType.datasets &&
          pieByLoanType.datasets[0]
        ) {
          // eslint-disable-next-line camelcase
          pieByLoanType.labels_i18n.forEach((i18n_label, index) => {
            const dataset = pieByLoanType.datasets[0];
            statusesData.push({
              name: this.$t(i18n_label),
              amount: dataset.data[index],
              color: dataset.backgroundColor[index],
            });
          });
        }
        this.chartData.pieByLoanType = [
          {
            categoryName: "Assets invested by Loan type",
            data: statusesData,
          },
        ];

        this.chartData.pieByLoanOriginator =
          response.charts.data.by_loan_originator;
        const pieByLoanOriginator = response.charts.data.by_loan_originator;
        statusesData = [];
        if (
          pieByLoanOriginator &&
          pieByLoanOriginator.datasets &&
          pieByLoanOriginator.datasets[0]
        ) {
          // eslint-disable-next-line camelcase
          pieByLoanOriginator.labels.forEach((label, index) => {
            const dataset = pieByLoanOriginator.datasets[0];
            statusesData.push({
              name: label,
              amount: dataset.data[index],
              color: dataset.backgroundColor[index],
            });
          });
        }
        this.chartData.pieByLoanOriginator = [
          {
            categoryName: this.$t("views.account.assetsInvestedByLO"),
            data: statusesData,
          },
        ];

        this.chartData.pieByLoanDuration =
          response.charts.data.by_remaining_term;
        const pieByLoanDuration = response.charts.data.by_remaining_term;
        statusesData = [];
        if (pieByLoanDuration && pieByLoanDuration.datasets) {
          // eslint-disable-next-line camelcase
          pieByLoanDuration.labels.forEach((label, index) => {
            const dataset = pieByLoanDuration.datasets;
            statusesData.push({
              name: label,
              amount: dataset.data[index],
              color: dataset.backgroundColor[index],
            });
          });
        }
        this.chartData.pieByLoanDuration = [
          {
            categoryName: this.$t(
              "views.account.assetsInvestedByRemainingLoan"
            ),
            data: statusesData,
          },
        ];

        this.isInvestorDataLoaded = true;
      })
      .catch((error) => {
        console.error("Error of investor details loading ", error);
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401 &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$store.state.investors.already_exists_message =
            error.response.data.message;
        } else if (error.response && error.response.status === 500) {
          // trying to load again. Actual for new users.
          window.location.href = "/account";
        } else {
          // Timeout, network failure or a gateway error: nothing above recovers, so mark
          // the load as failed and let the completion handler take the loader down.
          this.loadFailed = true;
        }
      })
      // This used to be `.then((this.isLoading = ...))`, which evaluated the assignment
      // at mount time and handed a boolean to .then(), so it never ran on completion and
      // a failed request left the loader spinning forever.
      .then(() => this.syncLoadingState());
  },
  methods: {
    // The single place that decides whether the spinner is up. Both watchers and the
    // request-completion handler route through here: the watchers fire again whenever the
    // store finishes loading, which on a fast failure happens *after* the error panel is
    // already showing, and re-deriving the flag without the loadFailed check put the
    // spinner straight back up with nothing left to take it down.
    syncLoadingState() {
      this.isLoading = this.loadFailed
        ? false
        : !(this.loaded && this.isInvestorDataLoaded);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>
<style scoped lang="scss">
.your {
  box-shadow: 0px 4px 16px rgba(48, 167, 254, 0.1);
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 15px;
  background: #ffffff;
}

.top {
  margin-top: 5px;
  min-height: 75px;
}

.future-cashflow {
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(48, 167, 254, 0.1);
  border-radius: 20px;
  margin-bottom: 15px;
  padding: 24px;
  h3 {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 1px;
    color: rgba(12, 45, 69, 0.8);
  }
}
.assets-chart-section {
  margin-bottom: 15px;
  h4 {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 1px;
    color: rgba(12, 45, 69, 0.8);
  }
  .income-tabs {
    .nav-item {
      width: 100% !important;
      a {
        width: 100% !important;
      }
    }
  }
}

.assets-chart {
  padding: 24px;
  box-shadow: 0px 4px 16px rgba(48, 167, 254, 0.1);
  border-radius: 20px;
  background: #ffffff;
}

.total-header {
  line-height: 47px;
}

.total-value {
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 44px;
  text-align: right;
  letter-spacing: 1px;
  color: rgba(12, 45, 69, 0.8);
  @media (max-width: 768px) {
    font-size: 22px;
  }
}

.header-description {
  color: #c3c3c3;
  font-size: 14px;
}

.overview {
  margin-bottom: 45px;
  margin-left: 5px;
  font-size: 13px;

  .col-12 {
    padding-left: 0;
  }

  .header,
  .header-value {
    font-size: 24px;
    font-weight: bold;
  }

  .header-value {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 1px;
    color: #30a7fe;
    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .info-title {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    color: #6d818f;
  }

  .header0 {
    font-family: Open Sans, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 1px;
    color: rgba(12, 45, 69, 0.8);
  }

  .total {
    font-weight: bold;
  }

  .info-table {
    div {
      margin-bottom: 5px;
    }

    img {
      min-height: 11px;
    }
  }
}

.strategies-link {
  width: 100%;
  text-align: center;
}

.help-tooltip {
  width: 18px;
  height: 18px;
  margin-top: -4px;
  cursor: pointer;
}

.nolist {
  list-style: none;
}
</style>
<style lang="scss">
.assets-chart-section {
  @media (max-width: 992px) {
    .income-tabs {
      .nav-item {
        width: 100%;
        a {
          width: 100%;
        }
      }
    }
  }
}
</style>
